import * as React from 'react';

import { IRoute } from 'lib/componentRouter';
import { Location } from 'lib/componentLocation';

import { WartsilaEnrichments, WartsilaEnrichmentsParams } from './model';
import { WartsilaEnrichmentsView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';
import { NavbarTab } from 'portcall/navbar/view';

export const WartsilaEnrichmentsRoute = (model : (params : WartsilaEnrichmentsParams) => WartsilaEnrichments, appwrapper : AppWrapper, request : Location) : IRoute => ({
    view:
        <AppWrapperView model={appwrapper} navbarTab={NavbarTab.Berths}>
            <WartsilaEnrichmentsView model={model(convertParams(request))} />
        </AppWrapperView>
});

function convertParams(request : Location) : WartsilaEnrichmentsParams {
    return {
        id: +(request.params["id"] || 0)
    };
}



// WEBPACK FOOTER //
// ./apps/wartsila/wartsilaenrichments/route.tsx